// B2b-2: shared labels + calls for project assignments. The backend is authoritative; these only shape the UI.
import { api, formatApiError } from "./api";

export const FOUNDER = "OWNER_SUPER_ADMIN";
export const TENANT_WIDE = ["OWNER_SUPER_ADMIN", "ADMINISTRATOR"];
export const EXTERNAL_COMPANY = ["SUBCONTRACTOR", "VENDOR_SUPPLIER", "CONTRACTOR_1099"];
export const ASSIGNED_ROLES = ["PROJECT_MANAGER", "SUPERINTENDENT", "FIELD_SUPERVISOR", "EMPLOYEE", "ARCHITECT",
  ...EXTERNAL_COMPANY];

export const PROJECT_ROLE_LABELS = {
  project_manager: "Project manager",
  superintendent: "Superintendent",
  field_supervisor: "Field supervisor",
  employee: "Team member",
  architect: "Architect",
  subcontractor: "Subcontractor",
  client_viewer: "Client (view)",
};

export const ACTION_LETTERS = { view: "V", create: "C", edit: "E", approve: "A", delete: "D" };

export function roleLabel(rop) {
  return PROJECT_ROLE_LABELS[rop] || rop || "—";
}

export function permissionSummary(perms) {
  if (!perms) return null;
  const parts = Object.entries(perms).map(([res, p]) =>
    `${res.replace(/_/g, " ")} ${(p.actions || []).map((a) => ACTION_LETTERS[a] || a).join("")}${p.scope === "O" ? " (own)" : ""}`);
  return parts.join(" · ");
}

export function errText(e) {
  return formatApiError(e?.response?.data?.detail) || "Something went wrong.";
}

export function cents(v) {
  return v == null ? null : `$${(v / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export const projectApi = {
  personnel: (pid, history) => api.get(`/projects/${pid}/personnel${history ? "?include_history=true" : ""}`),
  assignable: (pid) => api.get(`/projects/${pid}/assignable-users`),
  add: (pid, body) => api.post(`/projects/${pid}/assignments`, body),
  remove: (pid, aid, reason) => api.delete(`/projects/${pid}/assignments/${aid}`, { data: { reason } }),
  mine: () => api.get("/me/assignments"),
  userAssignments: (uid) => api.get(`/users/${uid}/assignments`),
  companyView: (uid) => api.get(`/admin/project-access/pm-company-view/${uid}`),
  setCompanyView: (uid, on) => (on ? api.post : api.delete)(`/admin/project-access/pm-company-view/${uid}`),
  settings: () => api.get("/admin/project-access/settings"),
  saveSettings: (fieldEnforcement) => api.put("/admin/project-access/settings", { field_enforcement: fieldEnforcement }),
  fieldDryRun: () => api.get("/admin/project-access/field-dry-run"),
  mySubcontract: (pid) => api.get(`/projects/${pid}/my-subcontract`),
};
